import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SellerView = () => {
  const { id } = useParams(); // seller_id from URL
  const navigate = useNavigate();

  const [seller, setSeller] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("Seller ID from URL:", id);

    if (!id) {
      toast.error("Seller ID missing");
      setLoading(false);
      return;
    }

    fetchSeller();
  }, [id]);

  const fetchSeller = async () => {
    try {
      const formData = new FormData();
      formData.append("seller_id", id);

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_seller_registration",
        formData
      );

      console.log("Fetch Seller Response:", response.data);

      if (response.data.status === true || response.data.status === "true") {
        setSeller(response.data.data);
      } else {
        toast.error(response.data.message || "Seller not found");
      }
    } catch (error) {
      console.error("Fetch seller error:", error);
      toast.error("Failed to fetch seller details");
    } finally {
      setLoading(false); // 🔥 VERY IMPORTANT
    }
  };

  // 🔄 Loading state
  if (loading) {
    return (
      <div className="text-center mt-5">
        <h5>Loading...</h5>
      </div>
    );
  }

  // ❌ No data
  if (!seller) {
    return (
      <div className="text-center mt-5">
        <h5>No seller data found</h5>
        <button className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>
          Back
        </button>
      </div>
    );
  }

  return (
    <div className="page-content">
    <div className="container-fluid py-4">
      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Seller Details</h5>
          <button className="btn btn-sm btn-secondary" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>

        <div className="card-body">
          <Detail label="Seller ID" value={seller.seller_id} />
          <Detail label="Business Name" value={seller.business_name} />
          <Detail label="Business Type" value={seller.business_type} />
          <Detail label="Brand Name" value={seller.brand_name} />
          <Detail label="Owner Name" value={seller.owner_name} />
          <Detail label="Email" value={seller.email} />
          <Detail label="Mobile" value={seller.mobile} />
          <Detail label="GST Number" value={seller.gst_number} />
          <Detail label="PAN Number" value={seller.pan_number} />
          <Detail label="Address" value={seller.address} />
          <Detail label="City" value={seller.city} />
          <Detail label="State" value={seller.state} />
          <Detail label="Pincode" value={seller.pincode} />
          <Detail label="Status" value={seller.status} />

          <hr />

          <h6>Documents</h6>

          <Document
            label="GST Document"
            file={seller.gst_document}
          />
          <Document
            label="Cancelled Cheque"
            file={seller.cancel_cheque_document}
          />
          <Document
            label="Trademark Certificate"
            file={seller.trademark_certificate}
          />
        </div>
      </div>
    </div>
    </div>
  );
};

/* 🔹 Reusable Components */

const Detail = ({ label, value }) => (
  <div className="row mb-2">
    <div className="col-md-4 fw-bold">{label}</div>
    <div className="col-md-8">{value || "-"}</div>
  </div>
);

const Document = ({ label, file }) => {
  if (!file) return null;

  return (
    <p>
      {label}:{" "}
      <a
        href={`https://cyberathon.com/multivendor/${file}`}
        target="_blank"
        rel="noreferrer"
      >
        View
      </a>
    </p>
  );
};

export default SellerView;
